import "./PromoSeason.scss";
import fdmobile from "./flyer-openhouse-mobile.png";
import fddesktop from "./flyer-openhouse-desktop.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";

const PromoSeason = () => {
  return (
    <div className="promoseason">
      <div className="container-promoseason">
        <div className="judul-promoseason">Promo Open House</div>
        <div className="gambardesktop">
          <img src={fddesktop} alt="flash-deals" />
        </div>
        <div className="gambarmobile">
          <img src={fdmobile} alt="flash-deals" />
        </div>
        <div className="promobutton">
          <button
            onClick={() =>
              window.open(
                "https://api.whatsapp.com/send?phone=6281188016089&text=Halo%20Wasen%20Saya%C2%A0bisa%20minta%20detail%20Katalog,%20Simulasi%20dan%20Promo%20terbaru%20rumah%20ini%20(Promo+Open+House)%20(https://www.podomoropark-bdg.com/)%20?&fbclid=PAAaa7g9IJ-tB3RyMunLD6w_5ysqP4oI6PA2d9Ml7Isc1_OXjeOiGuAqu7Ap0",
                "_blank",
              )
            }
            className="wabutton"
          >
            <FontAwesomeIcon icon={faWhatsapp} />
            &nbsp; Get More Promo
          </button>
        </div>
      </div>
    </div>
  );
};
export default PromoSeason;
